import { api } from './client';
import type { DiscoveryState } from './types';
import { useApi } from './useApi';
import { useAuth } from '../auth/AuthContext';

const none: DiscoveryState = {
  hasCatalogue: false,
  catalogueProviders: [],
  canFetch: false,
  catalogueInLibrary: false,
  catalogueInLibraryAvailable: false,
  playsOnDemand: false,
};

/// What this server offers beyond its own shelf.
///
/// Asked wherever it changes what is drawn, and cheap to ask: the answer is cached for the
/// session and shared between the screens that need it. Somebody who may look at the library is
/// allowed to ask too, because where the catalogue is the library, looking at the library is
/// looking at the catalogue. A refusal is a state rather than a failure - they simply get the
/// server as a library and nothing else.
export function useDiscoveryState(): DiscoveryState {
  const { can } = useAuth();

  const state = useApi(['discovery', 'state'], api.discoveryState, {
    enabled: can('Discover') || can('ViewLibraries'),
    staleTime: 30_000,
  });

  return state.data ?? none;
}
